import { Link } from 'react-router'
import { Button } from './ui/button'

export default function NotFound() {
  return (
    <div className="sm:px-6 md:px-8 lg:px-12 xl:px-16 flex items-center min-h-screen px-4 py-12 bg-white">
      <div className="w-full space-y-6 text-center">
        <div className="space-y-3">
          <h1 className="sm:text-5xl text-4xl font-bold tracking-tighter">404 Page Not Found</h1>
          <p className="text-gray-500">
            Sorry, we couldn&#x27;t find the page you&#x27;re looking for.
          </p>
        </div>
        <Button size="lg" asChild>
          <Link to="/">Return to website</Link>
        </Button>
      </div>
    </div>
  )
}
